// extracted by mini-css-extract-plugin
export default {"messageContainer":"Messages_messageContainer__dfqjD","messageHeader":"Messages_messageHeader__WNIqy","messageList":"Messages_messageList__avWFA","block":"Messages_block__IRrLV"};